module.exports = __webpack_public_path__ + "static/img/application1-4.fc0fcef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application1-4.jpg
// module id = R7vz
// module chunks = 0